import JourneyEventBuffer from "./JourneyEventBuffer";

/**
 * Centralized search tracking for journey events.
 */
export function trackSearch(entity, searchTerm) {
  if (!entity || !searchTerm || searchTerm.length < 2) return;
  try {
    JourneyEventBuffer.track("search", {
      event_data: {
        entity,
        search_term: String(searchTerm).substring(0, 50),
      },
    });
  } catch (e) {
    // Never break the app for tracking
  }
}
